var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"contents"},[_c('h1',[_vm._v(_vm._s(_vm.getTranslatedText(_vm.title)))]),_c('div',{staticClass:"line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }